import { DataGridTheme } from './DataGrid.types'

export const COLORS = {
  // primary
  primaryDark: '#02020A',
  primaryMedium: '#041F32',

  // accent
  accentExtraDark: '#0960D9',
  accentDark: '#0A6BF1',
  accentMedium: '#3788F7',
  accentLight: '#53ACFF',
  accentLightMedium: '#BADEFF',
  accentExtraLight: '#DEECFF',
  accentExtremelyLight: '#EDF5FF',

  // neutral
  neutralExtremelyDark3: '#54656E',
  neutralExtremelyDark2: '#5F727C',
  neutralExtremelyDark: '#6A7F8A',
  neutralExtraDark: '#94A4AD',
  neutralDark: '#C0C9CE',
  neutralMedium: '#E9EEF1',
  neutralLight: '#F2F5F7',
  neutralExtraLight: '#FAFBFC',

  // basic
  white: '#FFFFFF',
  black: '#000000',

  // shadow
  shadowBlur: '#E8EBED',
}

export const DEFAULT_THEME: DataGridTheme = {
  borderColor: COLORS.neutralMedium,
  borderColorResize: COLORS.accentMedium,
  borderColorGroupsAndPinned: COLORS.neutralMedium,
  borderWidth: 0,
  borderWidthHorizontal: 0,
  borderWidthVertical: 0,
  evenRowBackground: COLORS.white,
  firstColumnPadding: 30,
  fontSize: 14,
  header: {
    color: COLORS.neutralExtremelyDark,
    background: COLORS.white,
    bottomBorderWidth: 1,
    groupColor: COLORS.black,
    groupBackground: COLORS.white,
  },
  oddRowBackground: COLORS.neutralExtraLight,
  outerBorderWidth: 0,
  rowsGroupHeaderBackground: COLORS.neutralMedium,
  selectedRowBackground: COLORS.neutralLight,
}
